module.exports = __webpack_public_path__ + "media/images/icon/icons8-Email-8e438aa453c91efbf09e22762d6bf0e1.png";